import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

// Utils
import { WithCommonProps } from '@types';
export enum SpinnerSize {
  SIZE_SMALL = 24,
  SIZE_LARGE = 48,
}
export type SpinnerStyleProps = {
  /** Size of the spinner */
  size: SpinnerSize;
  /** Color of the spinner */
  color?: string;
};
export type SpinnerProps = WithCommonProps<unknown> & Partial<SpinnerStyleProps> & {
  /** Value controlling if it is loading */
  loading?: boolean;
};
export const Spinner = t0 => {
  const $ = _c(20);
  let classNameProp;
  let color;
  let otherProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      loading: t1,
      size: t2,
      color,
      className: classNameProp,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = classNameProp;
    $[2] = color;
    $[3] = otherProps;
    $[4] = t1;
    $[5] = t2;
  } else {
    classNameProp = $[1];
    color = $[2];
    otherProps = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const loading = t1 === undefined ? true : t1;
  const size = t2 === undefined ? SpinnerSize.SIZE_SMALL : t2;
  if (!loading) {
    return null;
  }
  let t3;
  if ($[6] !== classNameProp || $[7] !== color) {
    t3 = twMerge(cx("flex", {
      "text-primary-main": !color
    }), classNameProp);
    $[6] = classNameProp;
    $[7] = color;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const spinnerTailwindClassName = t3;
  let t4;
  if ($[9] !== color) {
    t4 = {
      color
    };
    $[9] = color;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== size) {
    t5 = <SVG size={size} />;
    $[11] = size;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== spinnerTailwindClassName || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={spinnerTailwindClassName} style={t4}>{t5}</div>;
    $[13] = spinnerTailwindClassName;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== otherProps || $[18] !== t6) {
    t7 = <div className="inline-flex align-items-center justify-content-center" {...otherProps}>{t6}</div>;
    $[17] = otherProps;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
const SVG: React.FC<{
  size: SpinnerSize;
}> = t0 => {
  const $ = _c(4);
  const {
    size
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      24: "w-6 h-6",
      48: "w-12 h-12"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const varyingStyles = t1;
  const t2 = `${"flex inline-flex font-normal text-base leading-[18.4px]"} ${varyingStyles[size]} animate-spinAnimation`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="100%" height="100%"><path fill="currentColor" d="M12.9 3.1c1.3 1.2 2.1 3 2.1 4.9 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-1.9 0.8-3.7 2.1-4.9l-0.8-0.8c-1.4 1.5-2.3 3.5-2.3 5.7 0 4.4 3.6 8 8 8s8-3.6 8-8c0-2.2-0.9-4.2-2.3-5.7l-0.8 0.8z" /></svg>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <span className={t2} role="img" aria-hidden="true" data-id="ICON-SPINNER">{t3}</span>;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};